import { Metamodel } from 'app/model/base/model';
import { DatasetFormatType } from './dataflow-dataset-settings';
import { SqlBaseSettings } from './sql-base-settings';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.sqlServer.dataflowSettings,
    validator: OnPremiseSqlServerSettings.validateSettings
})
export class OnPremiseSqlServerSettings extends SqlBaseSettings {
    public getFormat(): DatasetFormatType {
        return DatasetFormatType.OnPremiseSqlServer;
    }

    public getIconClass(): string {
        return 'i-100x100-SQLServer';
    }

    public initialize(subFormat: string): void {
        super.initialize(subFormat);
        this.store = DatasetFormatType.SqlDB;
    }
}
